import BaseService from './baseService';
import cloneDeep from 'lodash/cloneDeep'

class Company extends BaseService {
  	async getCompanyUser(id, opts = {}) {
		this.endPoint = '/company/'+id;
		return this.get(opts);
  	}
  	async createCompany(payload, opts = {}) {
		this.endPoint = '/company';
		return this.post(payload,opts);
  	}
  	async updateCompanyAttachment(payload, opts = {}) {
		this.endPoint = '/company/'+payload.id;
		const newOpts = cloneDeep(opts, {
		  headers: {
			'Content-Type': 'multipart/form-data'
		  }
		})
	
		return this.post(payload.data, newOpts)
  	}
  	async updateCompany(payload, opts = {}) {
		this.endPoint = '/company/'+payload.id;
		return this.post(payload.data,opts);
	}
	async removeImage(id,opts={}) {
		this.endPoint = 'deleteAttachmentCompany';
		return await this.delete(id,opts={});
	}
}

export default new Company();